import { useIntl } from 'react-intl';
import { createNumberCell } from 'components/table/DataTableUtil';

export function PercentCell({
  value,
  signDisplay = 'auto',
  className = '',
}: {
  value: number;
  signDisplay?: 'auto' | 'always' | 'never' | 'exceptZero' | 'negative';
  className?: string;
}) {
  const intl = useIntl();
  return createNumberCell(
    intl.formatNumber(value, {
      style: 'percent',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      signDisplay: signDisplay,
    }),
    className
  );
}
